export default __webpack_public_path__ + "static/media/cariesRiskIcon.5bf16e21.svg";